<section class="main-section-help-user-account" #addCustTop>
  <div id="addingCustomContent" class="main_section_headers" i18n="@@ipos-help.adding-custom-content-to-ipos.heading">Adding Custom Content to
    IPOS</div>

  <div class="accordion" id="addCustomContentAcc" #customContent>
    <!-- Section 1 -->
    <div id="customContentCard" class="card">
      <div class="card-header" id="headingOne">
        <div id="customContentCardHeader" class="card-header-content d-flex">
          <div id="customContentTitle" class="title" i18n="@@ipos-help.adding-custom-content-to-ipos.custom-group-title">CUSTOM CONTENT GROUP</div>
          <div id="tableCollapsable" class="table_collapse_link collapsed " data-toggle="collapse"
            [attr.aria-expanded]="isCustomContentGrpExpanded" aria-controls="collapseFour" id="customContentGroupDiv">
            <img (click)="showDescription('customContentGroup')"
              class="accordion_arrow chevron_down_dark table_row_expanded" alt="toggle section"
              [ngClass]="isCustomContentGrpExpanded?'transform-180':''" />
          </div>
        </div>
      </div>
      <div id="customContentGroup" aria-labelledby="headingThree" class="collapse spacing_style"
        id="collapseFour" data-parent="#customContentGroupDiv" #collapse="ngbCollapse"
        [(ngbCollapse)]="!isCustomContentGrpExpanded">
        <div id="customContentCardBody" class="card-body">
          <div id="customContentText" class="content">
            <p>
              <span i18n="@@ipos-help.adding-custom-content-to-ipos.up-to-3-pages">You can create custom content groups
                and up to <strong>3</strong> pages of
                content associated with <strong>Store Logo, Segments, Banner Carousel, Promotional Content</strong>
                and <strong>Price Content</strong>. This content will appear in the main display area of IPOS by clicking
                the respective sections.</span>
            </p>
            <p>
              <span i18n="@@ipos-help.adding-custom-content-to-ipos.follow-the-steps">Please follow the below steps for
                creating a custom content group</span>:
            </p>
            <ol>
              <li i18n="@@ipos-help.adding-custom-content-to-ipos.enter-publish-name">Enter a <strong>Published Name</strong> of up to
                <strong>50 characters</strong>. This name will be
                visible to shoppers and is a required field.</li>
              <li i18n="@@ipos-help.adding-custom-content-to-ipos.enter-internal-name">Enter an <strong>Internal Name</strong> of up to
                <strong>50 characters</strong>. This name will not be
                published; it is only meant to easily identify and
                distinguish the group from other groups.</li>
              <li i18n="@@ipos-help.adding-custom-content-to-ipos.select-publish-date-and-time">Select a <strong>Publish Date and Time</strong>. By
                default, it will be <strong>Now</strong>.</li>
              <li i18n="@@ipos-help.adding-custom-content-to-ipos.select-expiration-date-and-time">Select an <strong>Expiration Date and Time</strong>. By
                default, it will be <strong>Never</strong>.</li>
              <li i18n="@@ipos-help.adding-custom-content-to-ipos.save-and-proceed-button">Click the <strong>Save and Proceed</strong> button. After
                saving the group, you can add up to
                <strong>3</strong> content pages inside it.</li>
            </ol>
          </div>

          <!-- Preview image -->
          <img class="mb-3 help_content_group_new" alt="new content group" />
          <div id="previewImageContent" class="content">
            <p>
              <span i18n="@@ipos-help.adding-custom-content-to-ipos.note-form-factors"><strong>Note</strong>: For Promotional Content, Segments, Banner Carousel and Price Content, you can also select
              <strong>Form Factors</strong>. This will help to apply
              content for different manufacturers, processor models
              (e.g., Intel® Core™ i5), processor generations, or device types 
              (e.g., laptop, desktop, AIO). You can also create different content
              for Intel® devices and non-Intel devices.</span>
            </p>
            <p> {{ formFactorChangeText }} </p>
          </div>

          <!-- Preview image -->
          <img class="help-asset-promo-content" alt="form factors screen" />
        </div>
      </div>
    </div>

    <!-- Section 2 -->
    <div id="ccSection2Card" class="card" #content>
      <div class="card-header" id="headingTwo">
        <div id="section2CardHeader" class="card-header-content d-flex">
          <div id="section2CardTitle" class="title" i18n="@@ipos-help.adding-custom-content-to-ipos.custom-content-title">Custom content</div>
          <div id="section2TableCollapsable" class="table_collapse_link collapsed " data-toggle="collapse" [attr.aria-expanded]="isContentGrpExpanded"
            aria-controls="collapseThree" id="customContentDiv">
            <img (click)="showDescription('customContent')" class="accordion_arrow chevron_down_dark table_row_expanded"
              alt="toggle section" [ngClass]="isContentGrpExpanded?'transform-180':''" />
          </div>
        </div>
      </div>
      <div id="customContent" aria-labelledby="headingTwo" class="collapse spacing_style"
        id="collapseThree" data-parent="#customContentDiv" #collapse="ngbCollapse"
        [(ngbCollapse)]="!isContentGrpExpanded">
        <div id="section2CardBody" class="card-body">
          <div id="section2CardContent" class="content">
            <div id="groupContent" i18n="@@ipos-help.adding-custom-content-to-ipos.each-group-may-contain-text">Each page of a content group may contain:</div>
            <ul>
              <li i18n="@@ipos-help.adding-custom-content-to-ipos.upto-video-image">Up to <strong>1</strong> video or image, a title, and a
                block of custom copy. To upload your content, click the
                <strong>Upload Files</strong> button.</li>
              <li i18n="@@ipos-help.adding-custom-content-to-ipos.video-in-mp4">Videos must be saved in mp4 format and be less than
                <strong>60 seconds</strong> in length. Images must be in
                GIF, JPG, or PNG format.</li>
              <li i18n="@@ipos-help.adding-custom-content-to-ipos.body-limit-250">Body copy is limited to <strong>250 characters</strong>.</li>
              <li i18n="@@ipos-help.adding-custom-content-to-ipos.page-title-color">Page title text color can be customized. Body copy size
                and color can also be customized.</li>
            </ul>
            <div id="stepsForCustomContent">
              <span i18n="@@ipos-help.adding-custom-content-to-ipos.follow-the-steps-custom-content">Please follow the below steps to create custom content:</span>
            </div>
            <ol>
              <li i18n="@@ipos-help.adding-custom-content-to-ipos.enter-heading-page">Enter a <strong>Heading</strong> for the page.</li>
              <li i18n="@@ipos-help.adding-custom-content-to-ipos.select-font-color">Select the font color for your page title.</li>
              <li i18n="@@ipos-help.adding-custom-content-to-ipos.enter-body-page">Enter the <strong>Body</strong> of the page. This is
                limited to <strong>250 characters</strong>. You may also select your preferred font size, color, style and sentence ordering (ordered list or unordered list) from the text editor.</li>
              <li i18n="@@ipos-help.adding-custom-content-to-ipos.select-image-video">Select an image or video to include on the page.</li>
              <li i18n="@@ipos-help.adding-custom-content-to-ipos.button-to-add-page">Click the <strong>Add Page</strong> button to add more pages.</li>
              <li i18n="@@ipos-help.adding-custom-content-to-ipos.repeat-steps-each-page">Repeat steps 1-4 for each page of additional content. You
                may have up to <strong>3</strong> pages of additional
                content per section.</li>
              <li i18n="@@ipos-help.adding-custom-content-to-ipos.click-save-and-use-content-group">Click the <strong>Save and Use Content Group</strong> button.</li>
            </ol>
          </div>

          <!-- Preview image -->
          <img
            *ngIf="loginUserRole === 'retailHQUser' || loginUserRole === 'storeUser' || loginUserRole === 'intelAdmin' || loginUserRole === 'regionalHQ'"
            class="mb-3 help_content_edit" alt="edit content group" />
          <img
            *ngIf="loginUserRole !== 'retailHQUser' && loginUserRole !== 'storeUser' && loginUserRole !== 'intelAdmin' && loginUserRole !== 'regionalHQ'"
            class="mb-3 help_content_edit_unconnected" alt="edit content group" />
          <div id="previewImageContent2" class="content">
            <p>
              <span i18n="@@ipos-help.adding-custom-content-to-ipos.note-view-live-preview"><strong>Note</strong>: You can also view the live review of
              the page content and select the desired layout.</span>
            </p>
            <div id="contentPreview" class="content_figure_row text_align mb-3 d-flex">
              <img class="help_content_preview" alt="content preview" />
              <span i18n="@@ipos-help.adding-custom-content-to-ipos.content-feel-in-device">This area shows the content as it will look on the
                device. You can review the preview of the content before
                proceeding.</span>
            </div>
            <div id="contentlayout" class="content_figure_row">
              <img class="help_content_layout" alt="content layout" />
              <span i18n="@@ipos-help.adding-custom-content-to-ipos.select-the-layout">From here, you can select the layout from available
                presets.</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Section 3 -->
    <div id="ccSection3Card" class="card" #content>
      <div class="card-header" id="headingThree">
        <div id="section2CardHeader" class="card-header-content d-flex">
          <div id="section2CardTitle" class="title" i18n="@@ipos-help.adding-custom-content-to-ipos.custom-content-idle-experience-title">CUSTOM CONTENT GROUP ENHANCEMENTS FOR IDLE EXPERIENCE:</div>
          <div id="section2TableCollapsable" class="table_collapse_link collapsed " data-toggle="collapse" [attr.aria-expanded]="isCustomContentGrpExpandedIdleExperience"
            aria-controls="collapseThree" id="customContentDiv">
            <img (click)="showDescription('customContentGroupIdleExperience')" class="accordion_arrow chevron_down_dark table_row_expanded"
              alt="toggle section" [ngClass]="isCustomContentGrpExpandedIdleExperience?'transform-180':''" />
          </div>
        </div>
      </div>
      <div id="customContentGroupIdleExperience" aria-labelledby="headingThree" class="collapse spacing_style"
        id="collapseThree" data-parent="#customContentDiv" #collapse="ngbCollapse"
        [(ngbCollapse)]="!isCustomContentGrpExpandedIdleExperience">
        <div id="section2CardBody" class="card-body">
          <div id="section2CardContent" class="content">
            <div id="stepsForCustomContent">
              <span i18n="@@ipos-help.adding-custom-content-to-ipos.follow-the-steps-custom-promotional-content">According to the Idle Display selection, the idle experience will be different for different processors:</span>
            </div>
          </div>

          <!-- Preview image -->
          <img class="help_content_idle_experience_img1" alt="content preview" />
          <div id="previewImageContent2" class="content">
            <p>
              <span i18n="@@ipos-help.adding-custom-content-to-ipos.page-detail-section-tab">As soon as the user enters this page details section, two tabs will be displayed.</span>
            </p>
            <ol>
              <li i18n="@@ipos-help.adding-custom-content-to-ipos.ipos-preview">IPOS preview</li>
              <li i18n="@@ipos-help.adding-custom-content-to-ipos.experience-preview-idle">Idle Experience Preview</li>
            </ol>               
            <div id="contentPreview" class="content_figure_row text_align mb-3 d-flex">
              <img class="help_content_idle_experience_img2" alt="content preview" />
            </div>
            <p>
              <span i18n="@@ipos-help.adding-custom-content-to-ipos.page-detail-section-both-tab">Both tabs will contain the same information for the Page. That would be:</span>
            </p>
            <ol>
              <li i18n="@@ipos-help.adding-custom-content-to-ipos.theme-color">Theme color</li>
              <li i18n="@@ipos-help.adding-custom-content-to-ipos.background-color">Background color</li>
              <li i18n="@@ipos-help.adding-custom-content-to-ipos.content-heading">Heading</li>
              <li i18n="@@ipos-help.adding-custom-content-to-ipos.content-body">Body</li>
              <li i18n="@@ipos-help.adding-custom-content-to-ipos.content-color">Color</li>
              <li i18n="@@ipos-help.adding-custom-content-to-ipos.content-attachments">Attachments</li>
            </ol>               
            <div id="contentlayout" class="content_figure_row">
              <img class="help_content_idle_experience_img3" alt="content layout" />
              <span i18n="@@ipos-help.adding-custom-content-to-ipos.idle-experience-preview-layout">
                <strong>Note:</strong> If Idle Experience Preview is checked, then whenever that particular content group is shown during the idle experience, it should be shown in IPOS during idle experience in full screen.</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>